import { React } from '../../react';

import cx from './style.less';

export default ({ text, big }: { text: string, big?: boolean }) => (
  <div className={cx('component', { big })}>
    <div className={cx('text', { big })}>
      {text}
    </div>
  </div>
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/hint/index.tsx